import { c as _c } from "react/compiler-runtime";
import { ErrorMessage } from "@justhome/react-ui";
import RadioCard from "@justhome/react-ui/src/RadioCard";
import { propertyViewedStatusTypes } from "@lib/options";
import { QualificationFormData } from "@modules/booking/context/types";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import { useForm } from "react-hook-form";
import { Form, FormField, FormRow } from "../Form";
import FormSection from "../FormSection";
type PropertyViewingStatusFormValues = Pick<QualificationFormData, "propertyViewingStatus">;
interface PropertyViewingStatusFormProps {
  onSubmit: (data: PropertyViewingStatusFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const PropertyViewingStatusForm = t0 => {
  const $ = _c(28);
  const {
    onSubmit,
    canGoBack,
    onGoBack,
    isLoading,
    isError
  } = t0;
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    register,
    handleSubmit,
    formState: t2
  } = useForm(t1);
  const {
    errors
  } = t2;
  let t3;
  if ($[1] !== handleSubmit || $[2] !== onSubmit) {
    t3 = handleSubmit(onSubmit);
    $[1] = handleSubmit;
    $[2] = onSubmit;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("propertyViewingStatusForm.propertyViewingStatusLabel");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <label htmlFor="propertyViewingStatus" className="block text-title-1 mb-xs">{t4}</label>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== register || $[9] !== t) {
    t6 = propertyViewedStatusTypes.map(statusType => <RadioCard size="sm" key={statusType} value={statusType} type="radio" {...register("propertyViewingStatus", {
      required: t("propertyViewingStatusForm.propertyViewingStatusRequiredError")
    })}>{t(`propertyViewingStatusTypes.${statusType}`)}</RadioCard>);
    $[8] = register;
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <div className="grid m:grid-cols-2 gap-3xs">{t6}</div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== errors.propertyViewingStatus) {
    t8 = errors.propertyViewingStatus && <ErrorMessage>{errors.propertyViewingStatus?.message}</ErrorMessage>;
    $[13] = errors.propertyViewingStatus;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t7 || $[17] !== t8) {
    t9 = <FormRow><FormField>{t5}{t7}{t8}</FormField></FormRow>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t3 || $[20] !== t9) {
    t10 = <Form id="viewed-property-form" onSubmit={t3}>{t9}</Form>;
    $[19] = t3;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== canGoBack || $[23] !== isError || $[24] !== isLoading || $[25] !== onGoBack || $[26] !== t10) {
    t11 = <FormSection formId="viewed-property-form" canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>{t10}</FormSection>;
    $[22] = canGoBack;
    $[23] = isError;
    $[24] = isLoading;
    $[25] = onGoBack;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
};
export default PropertyViewingStatusForm;